import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminGroupEditTabs = ({
  groupId,
  activeTab,
  handleSwitchTab,
}) => {
  const intl = useIntl();

  return (
    <Nav tabs className="settings-tabs icon-tabs">
      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === '1' })}
          onClick={() => { handleSwitchTab('1'); }}
        >
          <i className="fa-solid fa-memo" />
          <span>{intl.formatMessage({ defaultMessage: 'Details' })}</span>
        </NavLink>
      </NavItem>
      {groupId && (
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => { handleSwitchTab('2'); }}
          >
            <i className="fa-solid fa-list-check" />
            <span>{intl.formatMessage({ defaultMessage: 'Capabilities' })}</span>
          </NavLink>
        </NavItem>
      )}
      {groupId && (
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '3' })}
            onClick={() => { handleSwitchTab('3'); }}
          >
            <i className="fa-solid fa-users" />
            <span>{intl.formatMessage({ defaultMessage: 'Users' })}</span>
          </NavLink>
        </NavItem>
      )}
    </Nav>
  );
};

AdminGroupEditTabs.propTypes = {
  groupId: PropTypes.string,
  activeTab: PropTypes.string.isRequired,
  handleSwitchTab: PropTypes.func.isRequired,
};

AdminGroupEditTabs.defaultProps = {
  groupId: null,
};

export default AdminGroupEditTabs;
